const initialState = {
    eventsByRecons: [],
    eventNamesForJSON: [],
};
export default initialState;
